export type TCustomTooltip = {
  children: any;
  message: string;
  isOnClick?: boolean;
  placement?: ECustomTooltipPlacement;
  slug?: string;
};

export enum ECustomTooltipPlacement {
  top = 'top',
  bottom = 'bottom',
  left = 'left',
  right = 'right',
}
